module.exports = __webpack_public_path__ + "img/member02.c437ffae.jpg";